/*!
*  Dapresy UI Library TableDesigner v0.2
*
*  Copyright Dapresy AB 2011
*  Authors: Goran Panic
*  All rights reserved
*
*/
(function ($) {
	/*!
	* DUItableDesigner
	* Author: Goran Panic
	* Purpose: Extend single table with designer capabilities.
	* Requirements: jQuery 1.5.2+
	* Parameters:
	*     options string   Optional - "getstyle" or "destroy"
	*/
	$.fn.DUItableDesigner = function (options) {
		var designer = this;

		this.evt = function () {
			this.mousedown = false;
		}


		this.ui = function () {
			this.parent = '';
			this.table = '';
			this.GUID = '';
		}


		this.GUID = function () {
			var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
			return id;
		}



		this.RGB2HEX = function (c) {
			//Based on: http://haacked.com/archive/2009/12/29/convert-rgb-to-hex.aspx
			var m = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/.exec(c);
			return m ? '#' + (1 << 24 | m[1] << 16 | m[2] << 8 | m[3]).toString(16).substr(1) : c;
		}



		this.getElemCSSProp = function (el, prop) {
			//Based on http://www.quirksmode.org/dom/getstyles.html
			var x = (typeof el === "string") ? document.getElementById(el) : el;
			var y;
			if (x.currentStyle) {
				var propi = prop.split('-');
				for (var i = 0; i < propi.length; i++) {
					prop = (i == 0) ? propi[0] : prop + propi[i].charAt(0).toUpperCase() + propi[i].slice(1);
				}
				y = x.currentStyle[prop];
			} else {
				y = document.defaultView.getComputedStyle(x, null).getPropertyValue(prop);
			}

			if ((y == 'thin' || y == 'medium' || y == 'thick') && $.browser.msie) {
				//border-width IE fix
				var thin = 1, medium = 1, thick = 1;
				var ieFactor = 0;
				switch ($.browser.version) {
					case '9.0':
						ieFactor = 1; break;
					case '8.0':
						ieFactor = 2; break;
					case '7.0':
						ieFactor = 2; break;
				}

				switch (y) {
					case 'thin': y = thin; break;
					case 'medium': y = medium; break;
					case 'thick': y = thick; break;
					default:
						if (parseInt(y) >= 1) {
							y = parseInt(y) + parseInt(ieFactor);
						}
						else {
							y = parseInt(y);
						}
				}
			}
			return y;
		}


		this.setCSSProp = function ($oThis) {
			if ($oThis.attr('data-css') == undefined) return false;

			var css = $oThis.attr('data-css').split(':');
			if (css.length < 2) return false;

			var $range = $(designer.ui.parent).find('.DUI-TD-SEL');
			$range.each(function () {
				var bs;
				var bc;
				var isDefault;
				switch (css[0]) {
					case 'border-width':
						bs = designer.getElemCSSProp($(this)[0], 'border-style');
						bc = designer.getElemCSSProp($(this)[0], 'border-bottom-color');
						isDefault = (bs == 'none' || bc == 'rgb(128, 128, 128)' || bs == 'inset' && $.browser.version == '7.0' && bc == '#f0f0f0');
						if (isDefault) { $(this).css('border-style', 'solid').css('border-color', '#000'); }
						break;
					case 'border-top-width':
						bs = designer.getElemCSSProp($(this)[0], 'border-top-style');
						bc = designer.getElemCSSProp($(this)[0], 'border-top-color');
						isDefault = (bs == 'none' || bc == 'rgb(128, 128, 128)' || bs == 'inset' && $.browser.version == '7.0' && bc == '#f0f0f0');
						if (isDefault) { $(this).css('border-top-style', 'solid').css('border-top-color', '#000'); }
						break;
					case 'border-bottom-width':
						bs = designer.getElemCSSProp($(this)[0], 'border-bottom-style');
						bc = designer.getElemCSSProp($(this)[0], 'border-bottom-color');
						isDefault = (bs == 'none' || bc == 'rgb(128, 128, 128)' || bs == 'inset' && $.browser.version == '7.0' && bc == '#f0f0f0');
						if (isDefault) { $(this).css('border-bottom-style', 'solid').css('border-bottom-color', '#000'); }
						break;
					case 'border-right-width':
						bs = designer.getElemCSSProp($(this)[0], 'border-right-style');
						bc = designer.getElemCSSProp($(this)[0], 'border-right-color');
						isDefault = (bs == 'none' || bc == 'rgb(128, 128, 128)' || bs == 'inset' && $.browser.version == '7.0' && bc == '#f0f0f0');
						if (isDefault) { $(this).css('border-right-style', 'solid').css('border-right-color', '#000'); }
						break;
					case 'border-left-width':
						bs = designer.getElemCSSProp($(this)[0], 'border-left-style');
						bc = designer.getElemCSSProp($(this)[0], 'border-left-color');
						isDefault = (bs == 'none' || bc == 'rgb(128, 128, 128)' || bs == 'inset' && $.browser.version == '7.0' && bc == '#f0f0f0');
						if (isDefault) { $(this).css('border-left-style', 'solid').css('border-left-color', '#000'); }
						break;
					case 'border-style':
						if (css[1] == 'double') { $(this).css('border-width', '3px').css('border-color', '#000'); }
						break;
					case 'border-top-style':
						if (css[1] == 'double') { $(this).css('border-top-width', '3px').css('border-top-color', '#000'); }
						break;
					case 'border-bottom-style':
						if (css[1] == 'double') { $(this).css('border-bottom-width', '3px').css('border-bottom-color', '#000'); }
						break;
					case 'border-right-style':
						if (css[1] == 'double') { $(this).css('border-right-width', '3px').css('border-right-color', '#000'); }
						break;
					case 'border-left-style':
						if (css[1] == 'double') { $(this).css('border-left-width', '3px').css('border-left-color', '#000'); }
						break;
					case 'font-size':
						if (css[1] == '1px') { $(this).text(''); }
						var fSize = parseFloat(css[1].replace('px', ''));
						var lHeight = Math.round(fSize * 1.20);
						$(this).css('line-height', lHeight + 'px');
						break;
				}
				$(this).css(css[0], css[1]);
			});
			//Redraw resizers
			designer.genColumnResizers();
		}

		this.setOuterCSSProp = function ($oThis) {
			//Not in use
			if ($oThis.attr('data-css') == undefined) return false;

			var css = $oThis.attr('data-css').split(':');
			if (css.length < 2) return false;

			var $range = $(designer.ui.parent).find('.DUI-TD-SEL');

			$range.each(function () {
				var cssx;
				if ($(this).prev().length == 0 || !$(this).prev().hasClass('DUI-TD-SEL')) {
					//inner column
					cssx = css[0].split('-');
					$(this).css(cssx[0] + '-left-' + cssx[1], css[1]);

					//if cell selected in previous row
					//$(this).css(cssx[0]+'-top-'+cssx[1],css[1]);

					//if cell selected in next row
					//$(this).css(cssx[0]+'-bottom-'+cssx[1],css[1]);
				}
				if ($(this).next().length == 0 || !$(this).next().hasClass('DUI-TD-SEL')) {
					//outer column
					cssx = css[0].split('-');
					$(this).css(cssx[0] + '-right-' + cssx[1], css[1]);

					//if cell selected in previous row
					//$(this).css(cssx[0]+'-top-'+cssx[1],css[1]);

					//if cell selected in next row
					//$(this).css(cssx[0]+'-bottom-'+cssx[1],css[1]);

				}
				if ($(this).prev().hasClass('DUI-TD-SEL') && $(this).next().hasClass('DUI-TD-SEL')) {
					//middle columns
					cssx = css[0].split('-');

					//if cell selected in previous row
					//$(this).css(cssx[0]+'-top-'+cssx[1],css[1]);

					//if cell selected in next row
					//$(this).css(cssx[0]+'-top-'+cssx[1],css[1]);
				}
			})

			//Redraw resizers
			designer.genColumnResizers();
		}


		this.getCellAbsoluteLeftPosition = function ($oThis) {
			//Returns the absolute position of a cell within a row,
			//when compared with all rows
			var $parent = $oThis.parent();
			var rowcols = $parent.children().length;
			var absLeft = 0;
			var i = $parent.index();
			var $ri = '';
			while (i >= 0) {
				$ri = $parent.parent().children().eq(i);
				if ($ri.children().length > absLeft) {
					absLeft = $ri.children().length;
				}
				i--;
			}
			absLeft = absLeft - rowcols + $oThis.index();

			return absLeft;
		}


		this.genToolbarTop = function () {
			var $d = $(designer.ui.parent);
			$d.append('<div class="DUI-TableDesigner DUI-TD-TB-TOP"></div>');
			$d.children('.DUI-TD-TB-TOP').append('<div class="DUI-TableDesigner DUI-TD-TB-GROUP" style="width:316px"></div>');
			$d.children('.DUI-TD-TB-TOP').children('.DUI-TD-TB-GROUP')
			.append('<img id="DUI-TD-BTN-SYS-SAVE" src="icons/save.png" title="Save Design"/>')
			.append('<img id="DUI-TD-BTN-SYS-CANCEL" src="icons/cancel.png" title="Cancel"/>')
			.append('<img id="DUI-TD-BTN-SYS-RESET" src="icons/reset.png" title="Reset"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-BOLD" src="icons/edit-bold.png" title="Bold"/>')
			.append('<img class="DUI-TD-BTN-ITALIC" src="icons/edit-italic.png" title="Italic"/>')
			.append('<img class="DUI-TD-BTN-UNDERLINE" src="icons/edit-underline.png" title="Underline"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-COLOR" src="icons/color.background.png" title="Colour Options"/>')
			.append('<img class="DUI-TD-BTN-FONT" src="icons/text-font.png" title="Font Styling"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-ALIGNLEFT" src="icons/text_align_left.png" title="Align Left"/>')
			.append('<img class="DUI-TD-BTN-ALIGNCENTER" src="icons/text_align_center.png" title="Align Center"/>')
			.append('<img class="DUI-TD-BTN-ALIGNRIGHT" src="icons/text_align_right.png" title="Align Right"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-BORDER" src="icons/border_remove.png" title="Style borders of the selection"/>')
			var pos = $($d).offset();
			$('.DUI-TD-TB-TOP').appendTo('body');
			$('.DUI-TD-TB-TOP').css(pos);
		}


		this.genToolbarLeft = function () {
			var $d = $(designer.ui.parent);
			$d.append('<div class="DUI-TableDesigner DUI-TD-TB-LEFT"></div>');
			$d.children('.DUI-TD-TB-LEFT').append('<div class="DUI-TableDesigner DUI-TD-TB-GROUP"></div>');
			$d.children('.DUI-TD-TB-LEFT').children('.DUI-TD-TB-GROUP')
			.append('<img class="DUI-TD-BTN-INSERTROW DUI-TD-BTND" src="icons/table-insert-row.png" title="Insert Row"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-DELETEROW DUI-TD-BTND" src="icons/table-delete-row.png" title="Delete Row"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-MERGE DUI-TD-BTND" src="icons/sql-join-outer.png" title="Merge Cells"/>')
			.append('<img class="DUI-TD-BTN-SPLIT DUI-TD-BTND" src="icons/sql-join-outer-exclude.png" title="Split Cell"/>')
			.append('<div class="DUI-TD-TB-DIV"></div>')
			.append('<img class="DUI-TD-BTN-EDITTEXT DUI-TD-BTND" src="icons/018.png" title="Edit Text"/>');
			var pos = $($d).offset();
			$('.DUI-TD-TB-LEFT').appendTo('body');
			$('.DUI-TD-TB-LEFT').css(pos);
		}


		this.genFontContextMenu = function (evt) {
			var m = [];
			m.push('<ul class="DUI-CONTEXTMENU" style="top:' + evt.pageY + 'px;left:' + evt.pageX + 'px;position:absolute">');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Font <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push('<ul>');
			m.push('<li data-css="font-family:Arial, Helvetica" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:Arial, Helvetica">Arial</li>');
			m.push('<li data-css="font-family:Comic Sans MS, Comic Sans" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:Comic Sans MS, Comic Sans">Comic Sans</li>');
			m.push('<li data-css="font-family:Courier New, Courier" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:Courier New, Courier">Courier New</li>');
			m.push('<li data-css="font-family:Georgia, serif" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:Georgia, serif">Georgia</li>');
			m.push('<li data-css="font-family:impact, charcoal" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:impact, charcoal">Impact</li>');
			m.push('<li data-css="font-family:lucida console, monaco" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:lucida console, monaco">Lucida Console</li>');
			m.push('<li data-css="font-family:palatino linotype, book antiqua, palatino" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:palatino linotype, book antiqua, palatino">Palatino Linotype</li>');
			m.push('<li data-css="font-family:tahoma, geneva, sans-serif" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:tahoma, geneva, sans-serif">Tahoma</li>');
			m.push('<li data-css="font-family:times new roman, times" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="font-family:times new roman, times">Times New Roman</li>');
			m.push('<li data-css="font-family:trebuchet ms, myriad pro, myriad" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="trebuchet ms, myriad pro, myriad, sans-serif">Trebuchet MS</li>');
			m.push('<li data-css="font-family:verdana, geneva, sans-serif" class="DUI-TD-FONT DUI-CONTEXTMENU-OPT" style="verdana, geneva, sans-serif">Verdana</li>');
			m.push('</ul>');
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Font Size <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push('<ul>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:1px">Hide text</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:2px">2px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:3px">3px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:4px">4px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:5px">5px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:6px">6px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:7px">7px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:8px">8px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:9px">9px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:10px">10px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:11px">11px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:12px">12px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:14px">14px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:16px">16px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:18px">18px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:20px">20px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:22px">22px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:24px">24px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:24px">24px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:28px">28px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:32px">32px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:36px">36px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:40px">40px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:44px">44px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:48px">48px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:54px">54px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:60px">60px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:66px">66px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:72px">72px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:80px">80px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:88px">88px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:96px">96px</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-FSIZE" data-css="font-size:100px">100px</li>');
			m.push('</ul>');
			m.push('</li>');
			m.push('</ul>');
			$('body').append(m.join(''));
		}


		this.genBorderContextMenu = function (evt) {
			var m = [];
			m.push('<ul class="DUI-CONTEXTMENU" style="top:' + evt.pageY + 'px;left:' + evt.pageX + 'px;position:absolute">');
			/*m.push('<li class="DUI-CONTEXTMENU-OPT" data-option="outer">')
			m.push('Outside Borders <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genBorderInContextMenu('border'));
			m.push('</li>');*/
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-BTN-BORDERALL">')
			m.push('All Borders <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genBorderInContextMenu('border'));
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-DIV">&#160;</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">')
			m.push('Top Border <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genBorderInContextMenu('border-top'));
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">')
			m.push('Bottom Border <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genBorderInContextMenu('border-bottom'));
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">')
			m.push('Left Border <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genBorderInContextMenu('border-left'));
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">')
			m.push('Right Border <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genBorderInContextMenu('border-right'));
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-DIV">&#160;</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT DUI-TD-BTN-BORDERREMOVE">No Border</li>');
			m.push('</ul>');
			$('body').append(m.join(''));
		}

		this.genBorderInContextMenu = function (cssProperty) {
			var p = cssProperty;
			var m = [];
			m.push('<ul class="DUI-CONTEXTMENU">');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Border Width <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push('<ul>');
			m.push('<li data-css="' + p + '-width:0" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">0px</li>');
			m.push('<li data-css="' + p + '-width:1px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT ">1px</li>');
			m.push('<li data-css="' + p + '-width:2px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">2px</li>');
			m.push('<li data-css="' + p + '-width:3px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">3px</li>');
			m.push('<li data-css="' + p + '-width:4px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">4px</li>');
			m.push('<li data-css="' + p + '-width:5px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">5px</li>');
			m.push('<li data-css="' + p + '-width:10px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">10px</li>');
			m.push('<li data-css="' + p + '-width:15px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">15px</li>');
			m.push('<li data-css="' + p + '-width:20px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">20px</li>');
			m.push('<li data-css="' + p + '-width:40px" class="DUI-TD-BWIDTH DUI-CONTEXTMENU-OPT">40px</li>');
			m.push('</ul>');
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Border Style <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push('<ul>');
			m.push('<li data-css="' + p + '-style:solid" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Solid</li>');
			m.push('<li data-css="' + p + '-style:dashed" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Dashed</li>');
			m.push('<li data-css="' + p + '-style:dotted" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Dotted</li>');
			m.push('<li data-css="' + p + '-style:none" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">None</li>');
			m.push('<li data-css="' + p + '-style:double" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Double</li>');
			m.push('<li data-css="' + p + '-style:groove" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Groove</li>');
			m.push('<li data-css="' + p + '-style:ridge" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Ridge</li>');
			m.push('<li data-css="' + p + '-style:inset" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Inset</li>');
			m.push('<li data-css="' + p + '-style:outset" class="DUI-TD-BSTYLE DUI-CONTEXTMENU-OPT">Outset</li>');
			m.push('</ul>');
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Border Color <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genColorPickerInContextMenu(p + '-color'));
			m.push('</li>');
			m.push('</ul>');
			return m.join('');
		}


		this.genColorContextMenu = function (evt) {
			var m = [];
			m.push('<ul class="DUI-CONTEXTMENU" style="top:' + evt.pageY + 'px;left:' + evt.pageX + 'px;position:absolute">');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Text Color <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genColorPickerInContextMenu('color'));
			m.push('</li>');
			m.push('<li class="DUI-CONTEXTMENU-OPT">');
			m.push('Background Color <div class="DUI-CONTEXTMENU-ARW"></div>');
			m.push(designer.genColorPickerInContextMenu('background-color'));
			m.push('</li>');
			m.push('</ul>');
			$('body').append(m.join(''));
		}


		this.genColorPickerInContextMenu = function (cssProperty) {
			var p = cssProperty;
			var m = [];
			m.push('<ul class="DUI-TD-CP">');
			m.push('<li>');
			m.push('<div class="DUI-TD-CPUI">');
			m.push('<div class="DUI-TD-DPUI-GROUP" style="top:2px">');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#fff" class="DUI-TD-CC" style="background-color:#fff"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#000" class="DUI-TD-CC" style="background-color:#000"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#eeecdf" class="DUI-TD-CC" style="background-color:#eeecdf"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#1f487c" class="DUI-TD-CC" style="background-color:#1f487c"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#4f81bc" class="DUI-TD-CC" style="background-color:#4f81bc"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#c0504e" class="DUI-TD-CC" style="background-color:#c0504e"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#9bbb58" class="DUI-TD-CC" style="background-color:#9bbb58"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#8064a1" class="DUI-TD-CC" style="background-color:#8064a1"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#4aacc5" class="DUI-TD-CC" style="background-color:#4aacc5"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#f79647" class="DUI-TD-CC" style="background-color:#f79647"><b><b></b></b></div></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-CPUI-GROUP" style="top:20px">');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#f2f2f2" class="DUI-TD-CC" style="background-color:#f2f2f2"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#d8d8d8" class="DUI-TD-CC" style="background-color:#d8d8d8"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#bfbfbf" class="DUI-TD-CC" style="background-color:#bfbfbf"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#a5a5a5" class="DUI-TD-CC" style="background-color:#a5a5a5"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#7f7f7f" class="DUI-TD-CC" style="background-color:#7f7f7f"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#7f7f7f" class="DUI-TD-CC" style="background-color:#7f7f7f"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#595959" class="DUI-TD-CC" style="background-color:#595959"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#3f3f3f" class="DUI-TD-CC" style="background-color:#3f3f3f"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#262626" class="DUI-TD-CC" style="background-color:#262626"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#0c0c0c" class="DUI-TD-CC" style="background-color:#0c0c0c"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#ded9c3" class="DUI-TD-CC" style="background-color:#ded9c3"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#c5bd98" class="DUI-TD-CC" style="background-color:#c5bd98"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#938a53" class="DUI-TD-CC" style="background-color:#938a53"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#494329" class="DUI-TD-CC" style="background-color:#494329"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#1d1b0f" class="DUI-TD-CC" style="background-color:#1d1b0f"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#c7d9f1" class="DUI-TD-CC" style="background-color:#c7d9f1"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#8db3e2" class="DUI-TD-CC" style="background-color:#8db3e2"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#548dd4" class="DUI-TD-CC" style="background-color:#548dd4"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#16365d" class="DUI-TD-CC" style="background-color:#16365d"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#0f243f" class="DUI-TD-CC" style="background-color:#0f243f"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#dce4f1" class="DUI-TD-CC" style="background-color:#dce4f1"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#b7cde2" class="DUI-TD-CC" style="background-color:#b7cde2"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#95b3d7" class="DUI-TD-CC" style="background-color:#95b3d7"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#366092" class="DUI-TD-CC" style="background-color:#366092"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#234060" class="DUI-TD-CC" style="background-color:#234060"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#f1dcdb" class="DUI-TD-CC" style="background-color:#f1dcdb"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#e3bab8" class="DUI-TD-CC" style="background-color:#e3bab8"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#da9695" class="DUI-TD-CC" style="background-color:#da9695"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#953735" class="DUI-TD-CC" style="background-color:#953735"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#622524" class="DUI-TD-CC" style="background-color:#622524"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#ecf1dd" class="DUI-TD-CC" style="background-color:#ecf1dd"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#d7e3bd" class="DUI-TD-CC" style="background-color:#d7e3bd"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#c3d79c" class="DUI-TD-CC" style="background-color:#c3d79c"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#78913d" class="DUI-TD-CC" style="background-color:#78913d"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#4f6029" class="DUI-TD-CC" style="background-color:#4f6029"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#e6e0ec" class="DUI-TD-CC" style="background-color:#e6e0ec"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#cdc1d9" class="DUI-TD-CC" style="background-color:#cdc1d9"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#b2a2c7" class="DUI-TD-CC" style="background-color:#b2a2c7"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#5f497a" class="DUI-TD-CC" style="background-color:#5f497a"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#3f3152" class="DUI-TD-CC" style="background-color:#3f3152"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#dbeef4" class="DUI-TD-CC" style="background-color:#dbeef4"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#b7dde8" class="DUI-TD-CC" style="background-color:#b7dde8"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#92cddb" class="DUI-TD-CC" style="background-color:#92cddb"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#30859a" class="DUI-TD-CC" style="background-color:#30859a"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#1f5967" class="DUI-TD-CC" style="background-color:#1f5967"><b><b></b></b></div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-K">');
			m.push('<div data-css="' + p + ':#fdeadb" class="DUI-TD-CC" style="background-color:#fdeadb"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#fcd5b6" class="DUI-TD-CC" style="background-color:#fcd5b6"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#f5c199" class="DUI-TD-CC" style="background-color:#f5c199"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#e36c08" class="DUI-TD-CC" style="background-color:#e36c08"><b><b></b></b></div>');
			m.push('<div data-css="' + p + ':#974806" class="DUI-TD-CC" style="background-color:#974806"><b><b></b></b></div>');
			m.push('</div>');
			m.push('</div>');
			m.push('<div class="DUI-TD-CPUI-GROUP" style="top:80px">');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#c00000" class="DUI-TD-CC" style="background-color:#c00000"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#fe0000" class="DUI-TD-CC" style="background-color:#fe0000"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#ffc000" class="DUI-TD-CC" style="background-color:#ffc000"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#fefe00" class="DUI-TD-CC" style="background-color:#fefe00"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#92d14f" class="DUI-TD-CC" style="background-color:#92d14f"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#00af50" class="DUI-TD-CC" style="background-color:#00af50"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#01b0f1" class="DUI-TD-CC" style="background-color:#01b0f1"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#0071c1" class="DUI-TD-CC" style="background-color:#0071c1"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#012060" class="DUI-TD-CC" style="background-color:#012060"><b><b></b></b></div></div>');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#7030a0" class="DUI-TD-CC" style="background-color:#7030a0"><b><b></b></b></div></div>');
			m.push('</div>');
            m.push('<div class="DUI-TD-CPUI-GROUP" style="top:100px">');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#EE248F" class="DUI-TD-CC" style="background-color:#EE248F"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#00ada8" class="DUI-TD-CC" style="background-color:#00ada8"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#5f388b" class="DUI-TD-CC" style="background-color:#5f388b"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#D31F00" class="DUI-TD-CC" style="background-color:#D31F00"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#EDF900" class="DUI-TD-CC" style="background-color:#EDF900"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#00DB95" class="DUI-TD-CC" style="background-color:#00DB95"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#16E000" class="DUI-TD-CC" style="background-color:#16E000"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#6ACE00" class="DUI-TD-CC" style="background-color:#6ACE00"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#D60003" class="DUI-TD-CC" style="background-color:#D60003"><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-K"><div data-css="' + p + ':#00BFC9" class="DUI-TD-CC" style="background-color:#00BFC9"><b><b></b></b></div></div>');
            m.push('</div>');
			m.push('<div class="DUI-TD-CPUI-GROUP" style="top:120px">');
			m.push('<div class="DUI-TD-K"><div data-css="' + p + ':transparent" class="DUI-TD-CC" style="background-color:transparent"><span style="background-color:#fff;width:5px;height:5px;display:block;float:left"></span><span style="background-color:#ccc;width:5px;height:5px;display:block;float:left"></span><span style="background-color:#ccc;width:5px;height:5px;display:block;float:left"></span><span style="background-color:#fff;width:5px;height:5px;display:block;float:left"></span><b><b></b></b></div></div>');
            m.push('<div class="DUI-TD-CUSTOMCOLOR"><div>#</div><input data-css="' + p + '" class="tabledesignerinput DUI-TD-CUSTOMCOLOR-INPUT" type="text" value="" maxlength="6" autocomplete="off"/></a>');
            m.push('</div>');
			m.push('</div>');
			m.push('</li>');
			m.push('</ul>');
			return m.join('');
		}


		this.genColumnResizers = function () {
			var $TABLE = $(designer.ui.table);
			var cols = []; //column positions
			$TABLE.find('tr').each(function (ind) {
				$(this).children().each(function (inx) {
					var leftPadd = parseInt(designer.getElemCSSProp($(this)[0], 'padding-left'));
					var rightPadd = parseInt(designer.getElemCSSProp($(this)[0], 'padding-right'));
					var leftBorder = parseInt(designer.getElemCSSProp($(this)[0], 'border-left-width'));
					var rightBorder = parseInt(designer.getElemCSSProp($(this)[0], 'border-right-width'));

					var childWidth = $(this).width() + leftPadd + rightPadd + leftBorder + rightBorder;
					if ($.browser.msie) {
						//msie returns different box-model than the others, also depending on if the border is defined
						if (leftBorder == 0) leftPadd = leftPadd - 1;
						if (rightBorder == 0) rightPadd = rightPadd - 1;

						childWidth = childWidth - leftPadd - rightPadd;
					}

					var absLeft = designer.getCellAbsoluteLeftPosition($(this));

					if (cols[absLeft] == undefined) {
						cols[absLeft] = parseInt(childWidth);
					} else {
						if (childWidth < cols[absLeft]) {
							cols[absLeft] = childWidth;
						}
					}
				});
			});


			//Delete old resizers
			$(designer.ui.parent).find('.DUI-TD-COLMOVEAREA').children().remove();
			//Create new resizers
			var aw = 0; //accumulated width
			var th = $(designer.ui.table).height(); //set correct height to column resizers

			for (var i = 0; i < cols.length; i++) {
				aw += cols[i];
				$(designer.ui.parent).find('.DUI-TD-COLMOVEAREA')
				.append('<div class="DUI-TD-COLMOVE" data-col="' + i + '" data-colWidth="' + cols[i] + '" style="left:' + parseInt(aw - 1) + 'px;height:' + th + 'px"></div>');
			}
		}


		this.destroy = function () {
			var $TDPlaceHolder = $(designer.ui.table).parent();
			var cloneStyle = $TDPlaceHolder.attr('style');
			var tHTML = $TDPlaceHolder.children('table').clone(false, false);
			tHTML.attr('style', cloneStyle);
			//Remove TDGUID
			var cList = tHTML.attr('class').split(/\s+/);
			for (var i = 0; i < cList.length; i++) {
				if (cList[i].length > 0) {
					if (cList[i].indexOf('TDGUID-') > -1) {
						tHTML.removeClass(cList[i]);
					}
				}
			}
			$TDPlaceHolder.children().remove();
			$TDPlaceHolder.replaceWith(tHTML);
		}


		this.exportStyleMapToJSON = function () {
			//Build JSON map of all table elements and their styles
			var c = [];
			var cssProps = ['background-color', 'color', 'font-family', 'font-size', 'font-style', 'font-variant', 'font-weight', 'line-height', 'text-align', 'text-decoration', 'width'];
			var $T = $(designer.ui.table);
			c.push('{ "table": [');
			c.push('{"tStyle":"border:' + $T.css('border-top-width') + ' ' + $T.css('border-right-width') + ' ' + $T.css('border-bottom-width') + ' ' + $T.css('border-left-width') + '"},');
			var TRiter = 0;
			$T.find('tr').each(function () {
				if (TRiter > 0) {
					c.push(',');
				}
				c.push('{"row":[');
				if ($(this).hasClass('DUI-TD-NEW')) {
					c.push('{"rNew":"true"},');
				}

				var TDiter = 0;
				$(this).children('td').each(function () {
					var o = $(this);
					if (TDiter > 0) {
						c.push(',');
					}
					c.push('{"cStyle":"');
					var _css = '';

					c.push('padding:' + o.css('padding-top') + ' ' + o.css('padding-right') + ' ' + o.css('padding-bottom') + ' ' + o.css('padding-left') + ';');
					c.push('border-top:' + o.css('border-top-width') + ' ' + o.css('border-top-style') + ' ' + designer.RGB2HEX(o.css('border-top-color')) + ';');
					c.push('border-right:' + o.css('border-right-width') + ' ' + o.css('border-right-style') + ' ' + designer.RGB2HEX(o.css('border-right-color')) + ';');
					c.push('border-bottom:' + o.css('border-bottom-width') + ' ' + o.css('border-bottom-style') + ' ' + designer.RGB2HEX(o.css('border-bottom-color')) + ';');
					c.push('border-left:' + o.css('border-left-width') + ' ' + o.css('border-left-style') + ' ' + designer.RGB2HEX(o.css('border-left-color')) + ';');
					c.push('margin:' + o.css('margin-top') + ' ' + o.css('margin-right') + ' ' + o.css('margin-bottom') + ' ' + o.css('margin-left') + ';');

					for (var i = 0; i < cssProps.length; i++) {
						_css = $(this).css(cssProps[i]).toString();
						if (_css != '') {
							if (_css.replace(/\s/g, '') == 'rgba(0,0,0,0)') {
								//skip transparent
							} else {
								switch (cssProps[i]) {
									//minify payload by skipping default values and make rgb2hex        
									case 'color':
									case 'background-color':
										c.push(cssProps[i] + ':' + designer.RGB2HEX(_css) + ';');
										break;
									case 'text-decoration':
										if (_css == 'none') continue;
										else c.push(cssProps[i] + ':' + _css + ';'); break;
									case 'text-align':
										if (_css != 'left' && _css != 'center' && _css != 'right') continue;
										else c.push(cssProps[i] + ':' + _css + ';'); break;
									case 'font-style':
									case 'font-variant':
									case 'line-height':
										if (_css == 'normal') continue;
										else c.push(cssProps[i] + ':' + _css + ';'); break;
									default:
										c.push(cssProps[i] + ':' + _css + ';');
										break;
								}
							}
						}
					}
					c.push('"');

					//Handle colspans for custom elements
					if ($(this).hasClass('DUI-TD-NEW') && $(this).attr('colspan') > 1) {
						c.push(',"cColspan":"' + $(this).attr('colspan') + '"');
					}

					//Handle #Text for custom elements
					if ($(this).hasClass('DUI-TD-NEW') && $(this).text().length > 0) {
						c.push(',"cText":"' + $(this).text() + '"');
					}

					c.push('}');
					TDiter++;
				});

				c.push(']}');
				TRiter++;
			});
			c.push(' ]}');
			return c.join('');
		}







		//iterate selector
		//return this.each(function(){
		this.each(function () {
			var $TABLE = $(this);
			var _this = $(this)[0];
			designer.ui.table = $TABLE;

			//sanity check
			if (_this.nodeName == 'TABLE' && !$TABLE.parent().hasClass('DUI-TableDesigner') && options == undefined) {
				//Identification
				var TDGUID = designer.GUID();
				designer.ui.GUID = 'TDGUID-' + TDGUID;
				$(designer).addClass('TDGUID-' + TDGUID);

				//wrap table to hold menus etc
				$TABLE.wrap('<div class="DUI-TableDesigner" style="' + $TABLE.attr('style') + '"></div>');
				$TABLE.css({ 'position': 'relative', 'left': '0', 'top': '0' })
				var $DESIGNER = $('.' + designer.ui.GUID).parent();
				designer.ui.parent = $DESIGNER;

				//Create Menu
				designer.genToolbarTop();
				designer.genToolbarLeft();

				//IE Selection
				_this.onselectstart = function () { return false; }

				//mouse trigger
				designer.evt.mousedown = false;

				//EVENT HANDLING (MAJOR PART OF THE PLUGIN)

				//ContextMenus/Menus
				$('body')
			.mousedown(function () {
				designer.evt.mousedown = true;
				if ($('.DUI-CONTEXTMENU').length > 0) {
					if ($('.DUI-CONTEXTMENU li.onmouseover').length < 1) {
						$('.DUI-CONTEXTMENU').remove();
						designer.genColumnResizers(); //redraw. needed for ie7
					}
				}
			})
			.mouseup(function () {
				designer.evt.mousedown = false;
			})

				//ContextMenus
				$('body')
			.delegate('.DUI-CONTEXTMENU li', 'mouseover', function () {
				$(this).addClass('onmouseover');
			})
			.delegate('.DUI-CONTEXTMENU li', 'mouseout', function () {
				$(this).removeClass('onmouseover');
			});


				//Cell selection logic
				$TABLE
			.delegate('td', 'mouseover', function () {
				if (designer.evt.mousedown) {
					if ($(designer.ui.parent).find('.DUI-TD-COLMOVE-DRAG').length > 0) {
						return; //not while resize in progress
					}

					if ($TABLE.find('.DUI-TD-EDIT').length < 1) {
						var anchorRowIndex = $TABLE.find('.DUI-TD-ANCHOR').parent().index();
						var anchorCellAbIndex = designer.getCellAbsoluteLeftPosition($TABLE.find('.DUI-TD-ANCHOR'));
						var lassoRowIndex = $(this).parent().index();
						var lassoCellAbIndex = designer.getCellAbsoluteLeftPosition($(this));

						$TABLE.find('td').removeClass('DUI-TD-LASSO'); //remove all previous flags
						$(this).addClass('DUI-TD-LASSO');

						$TABLE.find('tr').each(function (ind) {
							$(this).children('td').removeClass('DUI-TD-SEL');
							if (ind >= anchorRowIndex && ind <= lassoRowIndex || ind <= anchorRowIndex && ind >= lassoRowIndex) {
								$(this).children().each(function () {
									var pos = designer.getCellAbsoluteLeftPosition($(this));
									if (pos >= anchorCellAbIndex && pos <= lassoCellAbIndex ||
										pos <= anchorCellAbIndex && pos >= lassoCellAbIndex) {
										$(this).addClass('DUI-TD-SEL');
									}
								})
							}
						});
					}
				}
			})
			.delegate('td', 'mousedown', function (evt) {
				$TABLE.find('td').removeClass('DUI-TD-ANCHOR');
				var excelCtrl = ((/Mac OS/.test(navigator.userAgent))) ? evt.metaKey : evt.ctrlKey
				if ($TABLE.find('.DUI-TD-SEL').length > 0 && !excelCtrl && !evt.shiftKey) {
					if ($(this).hasClass('DUI-TD-SEL')) {
						$TABLE.find('.DUI-TD-SEL').removeClass('DUI-TD-SEL');
					} else {
						$TABLE.find('.DUI-TD-SEL').removeClass('DUI-TD-SEL');
						$(this).addClass('DUI-TD-SEL').addClass('DUI-TD-ANCHOR');
					}
				} else if (excelCtrl) {
					if ($(this).hasClass('DUI-TD-SEL')) {
						$(this).removeClass('DUI-TD-SEL');
					} else {
						$(this).addClass('DUI-TD-SEL');
					}
				} else if (evt.shiftKey) {
					$(this).addClass('DUI-TD-SEL');
				} else {
					$(this).addClass('DUI-TD-SEL').addClass('DUI-TD-ANCHOR');
				}
			})
			.delegate('td', 'mouseup', function (evt) {

				var selectedDOM = $TABLE.find('.DUI-TD-SEL');
				var selectedCells = selectedDOM.length;
				var isCellFocused = $(this).hasClass('DUI-TD-SEL');
				var isCustomCellFocused = $(this).hasClass('DUI-TD-NEW');
				var isSingleSel = (selectedCells == 1);
				var isMultiSel = (selectedCells > 1);
				var isPartialRowSelection = (selectedDOM.eq(0).parent().children('.DUI-TD-SEL').length == selectedCells);
				//new row
				if (isCellFocused && isSingleSel) {
					$('body').find('.DUI-TD-BTN-INSERTROW').removeClass('DUI-TD-BTND');
				} else {
					$('body').find('.DUI-TD-BTN-INSERTROW').addClass('DUI-TD-BTND');
				}
				//delete row
				if (isCellFocused && isCustomCellFocused && isSingleSel) {
					$('body').find('.DUI-TD-BTN-DELETEROW').removeClass('DUI-TD-BTND');
				} else {
					$('body').find('.DUI-TD-BTN-DELETEROW').addClass('DUI-TD-BTND');
				}
				//merge
				if (isCustomCellFocused && isMultiSel && isPartialRowSelection) {
					$('body').find('.DUI-TD-BTN-MERGE').removeClass('DUI-TD-BTND');
				} else {
					$('body').find('.DUI-TD-BTN-MERGE').addClass('DUI-TD-BTND');
				}
				//split
				if (isCustomCellFocused && isSingleSel) {
					$('body').find('.DUI-TD-BTN-SPLIT').removeClass('DUI-TD-BTND');
				} else {
					$('body').find('.DUI-TD-BTN-SPLIT').addClass('DUI-TD-BTND');
				}
				//edit text
				if (isCustomCellFocused && isSingleSel) {
					$('body').find('.DUI-TD-BTN-EDITTEXT').removeClass('DUI-TD-BTND');
				} else {
					$('body').find('.DUI-TD-BTN-EDITTEXT').addClass('DUI-TD-BTND');
				}
			});
				//end cell selection logic


				//Initate column resizers
				//Placeholders
				$('<div class="DUI-TD-COLMOVE-INFO"><span>0</span>px</div>').insertBefore($TABLE);
				$('<div class="DUI-TD-COLMOVEAREA"></div>').insertBefore($TABLE);
				$('<div class="DUI-TD-COLMOVE-BG"></div>').insertBefore($TABLE);
				var colmoveBG = $(designer.ui.parent).find('.DUI-TD-COLMOVE-BG')[0];
				colmoveBG.onmousedown = function () { return false; }
				colmoveBG.onselectstart = function () { return false; }
				designer.genColumnResizers();


				//Column Resizer Event Logic
				$DESIGNER
			.delegate('.DUI-TD-COLMOVE', 'mousedown', function () {
				if ($(this).hasClass('DUI-TD-COLMOVE-DRAG')) {
					$(this).removeClass('DUI-TD-COLMOVE-DRAG');
					$(designer.ui.parent).find('.DUI-TD-COLMOVE-INFO').hide();
					$(designer.ui.parent).find('.DUI-TD-COLMOVE-BG').hide();
				} else {
					$(this).addClass('DUI-TD-COLMOVE-DRAG');
				}
			});

				$(document)
				.delegate('body', 'mousemove', function (evt) {
					//move column with the mouse, while mousedown
					if ($(designer.ui.parent).find('.DUI-TD-COLMOVE-DRAG').length > 0) {
						var $o = $(designer.ui.parent).find('.DUI-TD-COLMOVE-DRAG');
						var oLeft = parseInt($o.css('left'));
						var oParentLeft = parseInt($o.offset().left - oLeft);
						var relLeft = evt.pageX - oParentLeft;
						var relTop = evt.pageY - parseInt($o.offset().top - parseInt($o.css('top')));
						var minLeft = 10;

						if (relLeft > minLeft) {
							$(designer.ui.parent).find('.DUI-TD-COLMOVE-DRAG').css('left', relLeft + 'px');
							$(designer.ui.parent).find('.DUI-TD-COLMOVE-BG').show();
							$(designer.ui.parent).find('.DUI-TD-COLMOVE-INFO')
							.css({ 'left': relLeft + 'px', 'top': relTop + 'px' })
							.show()
							.children('span').text(relLeft);
						}
					}
				})
				.delegate('body', 'mouseup', function (evt) {
					if ($(designer.ui.parent).find('.DUI-TD-COLMOVE-DRAG').length > 0) {
						var $oThis = $(designer.ui.parent).find('.DUI-TD-COLMOVE-DRAG');
						var thisElIndex = $oThis.index();
						var precedingAcuWidth = 0;
						$oThis.parent().children().each(function (ind) {
							if (ind >= thisElIndex) return;
							precedingAcuWidth += parseInt($(this).attr('data-colWidth'));
						});

						var table = $oThis.parent().parent();
						var colPos = $oThis.position().left;
						var columnID = $oThis.attr('data-col');

						table.find('tr').each(function () {
							var fullWidth = $(designer.ui.parent).find('.DUI-TD-COLMOVE-INFO').children("span").text();
							colPos = fullWidth - precedingAcuWidth;
							if (colPos < 10) {
								colPos = fullWidth;
							}
							$(this).children().each(function (ind) {
								var absLeft = designer.getCellAbsoluteLeftPosition($(this));
								if (absLeft == columnID) {
									$(this).css('width', colPos);
								}
							})
						});
						$oThis.removeClass('DUI-TD-COLMOVE-DRAG');
						$(designer.ui.parent).find('.DUI-TD-COLMOVE-INFO').hide();
						$(designer.ui.parent).find('.DUI-TD-COLMOVE-BG').hide();
						//redraw resizers
						designer.genColumnResizers();
					}
				});



				//Toolbar buttons
				$('body')
		.delegate('.DUI-TD-BTN-BOLD', 'click', function () {
			$DESIGNER.find('.DUI-TD-SEL').each(function () {
				var w = $(this).css('font-weight');
				var c = (w == 'bold' || w == '700') ? '' : 'bold';
				$(this).css('font-weight', c);
			});
			designer.genColumnResizers();
		})
		.delegate('.DUI-TD-BTN-ITALIC', 'click', function () {
			$DESIGNER.find('.DUI-TD-SEL').each(function () {
				var c = ($(this).css('font-style') == 'italic') ? '' : 'italic';
				$(this).css('font-style', c);
			});
			designer.genColumnResizers();
		})
		.delegate('.DUI-TD-BTN-UNDERLINE', 'click', function () {
			$DESIGNER.find('.DUI-TD-SEL').each(function () {
				var c = ($(this).css('text-decoration') == 'underline') ? '' : 'underline';
				$(this).css('text-decoration', c);
			});
			designer.genColumnResizers();
		})
		.delegate('.DUI-TD-BTN-ALIGNLEFT', 'click', function () {
			$DESIGNER.find('.DUI-TD-SEL').each(function () {
				var c = ($(this).css('text-align') == 'left') ? '' : 'left';
				$(this).css('text-align', c);
			});
		})
		.delegate('.DUI-TD-BTN-ALIGNCENTER', 'click', function () {
			$DESIGNER.find('.DUI-TD-SEL').each(function () {
				var c = ($(this).css('text-align') == 'center') ? '' : 'center';
				$(this).css('text-align', c);
			});
		})
		.delegate('.DUI-TD-BTN-ALIGNRIGHT', 'click', function () {
			$DESIGNER.find('.DUI-TD-SEL').each(function () {
				var c = ($(this).css('text-align') == 'right') ? '' : 'right';
				$(this).css('text-align', c);
			});
		})
		.delegate('.DUI-TD-BTN-BORDERREMOVE', 'click', function () {
			var $range = $DESIGNER.find('.DUI-TD-SEL');
			if ($range.length > 0) {
				$range.css('border', '0px solid #000');
			} else {
				$TABLE
					.css('border', '0')
					.find('td').css('border', '0px solid #000');
			}
			designer.genColumnResizers();
		})
		.undelegate('.DUI-TD-BTN-BORDER', 'click')
		.delegate('.DUI-TD-BTN-BORDER', 'click', function (evt) {
			designer.genBorderContextMenu(evt);
		})
		.undelegate('.DUI-TD-BTN-COLOR', 'click')
		.delegate('.DUI-TD-BTN-COLOR', 'click', function (evt) {
			designer.genColorContextMenu(evt);
		})
		.delegate('.DUI-TD-BTN-FONT', 'click', function (evt) {
			designer.genFontContextMenu(evt);
		})
		.delegate('.DUI-TD-FONT', 'click', function () {
			//Font Family
			designer.setCSSProp($(this));
		})
		.delegate('.DUI-TD-FSIZE', 'click', function () {
			//Font Size
			designer.setCSSProp($(this));
		})
		.delegate('.DUI-TD-BWIDTH', 'click', function () {
			//Border Width
			if ($(this).parent().parent().parent().parent().attr('data-option') == 'outer') {
				designer.setCSSProp($(this));
			} else {
				designer.setCSSProp($(this));
			}
			//Fix Rendering issue in Chrome (after setting border-width, some cells do not render correctly)
			$TABLE.height($TABLE.height());
			designer.genColumnResizers();
		})
		.delegate('.DUI-TD-BSTYLE', 'click', function () {
			//Border Style
			designer.setCSSProp($(this));
			//Fix Rendering issue in Chrome (after setting border-width, some cells do not render correctly)
			$TABLE.height($TABLE.height());
			designer.genColumnResizers();
		})
		.delegate('.DUI-TD-CC', 'click', function () {
			//ColourPicker
			designer.setCSSProp($(this));
		})
		.undelegate('.tabledesignerinput.DUI-TD-CUSTOMCOLOR-INPUT', 'blur')
		.delegate('.tabledesignerinput.DUI-TD-CUSTOMCOLOR-INPUT', 'blur', function(){
			var c = $(this).val();

			if (c.length && !(c.length != 6 || isNaN(parseInt(c, 16)))){
				var prop = $(this).attr('data-css').split(':')[0];
				$(this).attr('data-css', prop+':#'+c);
				designer.setCSSProp($(this));
				$(this).val('');
				$(this).css('background-color','');
			} else {
				if( c.length > 0 ){
					$(this).css('background-color','#efb1bc');
				}
			}
		})
		.undelegate('.tabledesignerinput.DUI-TD-CUSTOMCOLOR-INPUT', 'keydown')
		.delegate('.tabledesignerinput.DUI-TD-CUSTOMCOLOR-INPUT', 'keydown', function(evt){
			if( evt.keyCode == 13 ) {
				evt.preventDefault();
				$(this).blur();
			}
		})
		.delegate('.DUI-TD-BTN-INSERTROW', 'click', function () {
			if ($(this).hasClass('DUI-TD-BTND')) {
				return false; //Button is disabled
			}

			var $range = $DESIGNER.find('.DUI-TD-SEL');
			if ($range.length == 1) {
				var $parent = $DESIGNER.find('.DUI-TD-SEL').parent();
				var iChildren = $parent.children().length;
				$parent.children().each(function () {
					if ($(this).attr('rowspan') > 1) {
						iChildren--
					}
				});

				var childrenHTML = [];
				childrenHTML.push('<tr class="DUI-TD-NEW">');
				var inheritStyle = '';
				var colspanInt = 1;
				for (var i = 0; i < iChildren; i++) {
					//FIXME: this is incorrect if the parent has more cells than this row?
					inheritStyle = $parent.children().eq(i).attr('style');
					inheritStyle = (inheritStyle == undefined) ? '' : inheritStyle;
					colspanInt = $parent.children().eq(i).attr('colspan');
					childrenHTML.push('<td class="DUI-TD-NEW" colspan="' + colspanInt + '" style="' + inheritStyle + '">&#160;</td>');
				}
				childrenHTML.push('</tr>');
				$(childrenHTML.join('')).insertAfter($parent);

				// Handle rowspan calculations for previous elements
				var thisRowCols = $parent.children().length;
				// Absolute left-position of this element
				var thisAbsLeftPos = 0;
				var j = $parent.index();
				var $ri = '';
				while (j > 0) {
					$ri = $parent.parent().children().eq(i);
					if ($ri.children().length > thisAbsLeftPos) {
						thisAbsLeftPos = $ri.children().length;
					}
					j--;
				}
				//the relative position of the first item in our row
				thisAbsLeftPos = thisAbsLeftPos - thisRowCols;

				// Get absolute top-position of any row above that has more columns that this one
				var y = $parent.index();
				var yStatic = y;
				var yLimit = thisRowCols;
				var $ry = '';
				while (y >= 0) {
					$ry = $parent.parent().children().eq(y);
					if ($ry.children().length > yLimit || y == yStatic) {
						yLimit = $ry.children().length;
						$ry.children().each(function () {
							if ($(this).attr('rowspan') > 1) {
								$(this).attr('rowspan', parseInt($(this).attr('rowspan') + 1));
							}
						})
					}
					y--;
				}
				//redraw resizers
				designer.genColumnResizers();
			}
		})
		.delegate('.DUI-TD-BTN-DELETEROW', 'click', function () {
			if ($(this).hasClass('DUI-TD-BTND')) {
				return false; //Button is disabled
			}
			var $range = $DESIGNER.find('.DUI-TD-SEL');
			if ($range.length == 1 && $range.hasClass('DUI-TD-NEW')) {
				var $parent = $DESIGNER.find('.DUI-TD-SEL').parent();
				$parent.remove();

				// Handle rowspan calculations for previous elements
				var thisRowCols = $parent.children().length;
				// Absolute left-position of this element
				var thisAbsLeftPos = 0;
				var i = $parent.index();
				var $ri = '';
				while (i > 0) {
					$ri = $parent.parent().children().eq(i);
					if ($ri.children().length > thisAbsLeftPos) {
						thisAbsLeftPos = $ri.children().length;
					}
					i--;
				}
				//the relative position of the first item in our row
				thisAbsLeftPos = thisAbsLeftPos - thisRowCols;

				// Get absolute top-position of any row above that has more columns that this one
				var y = $parent.index();
				var yLimit = thisRowCols;
				var $ry = '';
				while (y >= 0) {
					$ry = $parent.parent().children().eq(y);
					if ($ry.children().length > yLimit) {
						yLimit = $ry.children().length;
						$ry.children().each(function () {
							if ($(this).attr('rowspan') > 1) {
								$(this).attr('rowspan', parseInt($(this).attr('rowspan') - 1));
							}
						})
					}
					y--;
				}

				//Redraw resizers
				designer.genColumnResizers();

				//Trigger toolbar handling
				$TABLE.find('td:first').mouseup();
			}
		})
		.delegate('.DUI-TD-BTN-MERGE', 'click', function () {
			var $range = $DESIGNER.find('.DUI-TD-SEL');
			if ($(this).hasClass('DUI-TD-BTND') && $DESIGNER.find('.DUI-TD-SEL').eq(0).parent().children('.DUI-TD-SEL').length == $DESIGNER.find('.DUI-TD-SEL').length) {
				return false; //Button is disabled
			}

			if ($range.length > 1) {
				if ($range.hasClass('DUI-TD-NEW')) {
					//TODO: This can only handle single row selection
					//Count selected cells.
					var cells = $range.parent().children();

					//Get all the text
					var cellText = [];
					cells.each(function (ind) {
						cellText.push(cells.eq(ind).text());
					});
					//Remove the other cells.
					var colspanInt = 0;
					$range.each(function (ind) {
						colspanInt += $(this).attr('colspan');
						if (ind > 0) {
							$range.eq(ind).remove();
						}
					});
					//Set colspan and text
					$range.eq(0).attr('colspan', colspanInt);
					$range.eq(0).text(cellText.join(''));

					//Redraw resizers
					designer.genColumnResizers();
					//Trigger toolbar handling
					$TABLE.find('td:first').mouseup();
				}
			}
		})
		.delegate('.DUI-TD-BTN-SPLIT', 'click', function () {
			if ($(this).hasClass('DUI-TD-BTND')) {
				return false; //Button is disabled
			}
			var $range = $DESIGNER.find('.DUI-TD-SEL');
			if ($range.length == 1) {
				if ($range.hasClass('DUI-TD-NEW')) {
					//TODO: Should only be added if there is enough columns?
					//TODO: Decrease colspan by 1 of splitted cell if bigger than 1?
					//FIXME: Should take into account the maximum number of cells in the table so that it does not exeed it?
					var selectedColSpan = $DESIGNER.find('.DUI-TD-SEL').eq(0).attr('colspan');
					if (selectedColSpan > 1) {
						$DESIGNER.find('.DUI-TD-SEL').eq(0).attr('colspan', selectedColSpan - 1);
					}
					//Split it
					//FIXME: it should get the style of the current cell??
					$('<td colspan="1" class="DUI-TD-NEW">&#160;</td>').insertAfter($DESIGNER.find('.DUI-TD-SEL'));

					//Redraw resizers
					designer.genColumnResizers();
				}
			}
		})
		.delegate('.DUI-TD-BTN-EDITTEXT', 'click', function () {
			if ($(this).hasClass('DUI-TD-BTND')) {
				return false; //Button is disabled
			}
			var $range = $DESIGNER.find('.DUI-TD-SEL');
			if ($range.length == 1) {
				if ($range.hasClass('DUI-TD-NEW')) {
					var _text = $range.text();
					$range.text('');
					var w = 0;
					w += parseInt(designer.getElemCSSProp($range[0], 'width'), 10);
					w += parseInt(designer.getElemCSSProp($range[0], 'padding-left'), 10);
					w += parseInt(designer.getElemCSSProp($range[0], 'padding-right'), 10);
					w += parseInt(designer.getElemCSSProp($range[0], 'border-left-width'), 10);

					var extraCSS = '';
					if ($.browser.mozilla) {
						extraCSS = 'position:relative;'; //otherwise it ends up in the 
					}

					$range.html('<input class="DUI-TD-EDIT" type="text" style="border:0;padding:0;margin:0;width:' + w + 'px;height:auto;' + extraCSS + '" value="' + _text + '"/>&#160;');
					$DESIGNER.find('.DUI-TD-SEL').children('.DUI-TD-EDIT')
					.blur(function () {
						if ($(this).val().length > 0) {
							$(this).parent().text($(this).val());
						} else {
							$(this).parent().text(' '); //if empty
						}
						//Remove editor
						$(this).parent().children('input').remove();
						//Redraw resizers
						designer.genColumnResizers();
					})
					.focus();
				}
			}
		});
			} //end only tables (sanity check)
		})

		// Special options
		if (options == 'getstyle') {
			if (this.length == 1 && this.parent().hasClass('DUI-TableDesigner')) {
				return designer.exportStyleMapToJSON();
			}
		}

		if (options == 'destroy') {
			if (this.length == 1 && this.parent().hasClass('DUI-TableDesigner')) {
				designer.destroy();
			}
		}

	};
})(jQuery);